import { render, staticRenderFns } from "./ChangeStartEnd.vue?vue&type=template&id=4c252288&"
import script from "./ChangeStartEnd.vue?vue&type=script&lang=js&"
export * from "./ChangeStartEnd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports